import React, { useState, useEffect } from "react";
import axios from "axios";
import { Search } from "lucide-react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
const SalespersonView = ({ isEdit, setIsEdit, reload, setreload }) => {
  const [salespersons, setSalespersons] = useState([]);
  const [filteredSalespersons, setFilteredSalespersons] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    type: "success",
  });
  const navigate = useNavigate();

  useEffect(() => {
    fetchSalespersons();
  }, []);

  useEffect(() => {
    fetchSalespersons();
  }, [reload]);

  const fetchSalespersons = async () => {
    setIsLoading(true);
    setError(null);

    let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;

    const apiUrl =
      `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/SPERSONMASTERLIST/-/-`;

    try {
      const response = await axios.get(apiUrl);

      // response should be an array
      setSalespersons(response.data);
      setFilteredSalespersons(response.data);

      console.log("Fetched Salespersons:", response.data);
    } catch (err) {
      console.error("Error fetching salespersons:", err);
      setError("Failed to fetch salesperson list.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async () => {
    if (!searchTerm.trim()) return;
    setIsLoading(true);
    try {

      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;

      const apiUrl = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/SPERSONMASTERLIST/${searchTerm}/-`;
      const response = await axios.get(apiUrl);
      setFilteredSalespersons(response.data);
      console.log("Search results:", response.data);
    } catch (error) {
      console.error("Error searching salesperson:", error);
    } finally {
      setIsLoading(false);
    }
  };

  //   const onBack = () => navigate("/salesperson");
  const onEdit = (sp) => {
    setIsEdit(true);
    console.log("Salesperson To Edit:", sp);
    navigate("/salespersonCreation", { state: sp });
  };
  const onDeleteSp = async (sp) => {
    console.log("sp:", sp);
    if (!sp || !sp.code) return;

    // Optional: confirm before deleting
    const confirmDelete = window.confirm(
      `Are you sure you want to delete salesperson "${sp.Salesperson_Name}"?`
    );
    if (!confirmDelete) return;

    try {

       let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;

      const payload = [
        {
          CmpCode: company_code_from_local_storage,
          mode: "DELETE",
          scode: sp.code,
          sname: sp.Salesperson_Name,
          target: sp.Target,
          deptno: sp.deptno,
          location: sp.Account,
          email: sp.Email || sp.email,
          mobileno: sp.MobileNo,
        },
      ];

      const apiURL = `${apiBaseURL}/api/CRMSalespersonReg`;
      const response = await axios.post(apiURL, payload);

      console.log("Delete Response:", response.data);

      setSnack({
        open: true,
        message: "Salesperson deleted successfully!",
        type: "success",
      });

      // Trigger reload in SalespersonView
      setreload((prev) => !prev);
    } catch (error) {
      console.error("Error deleting salesperson:", error);

      setSnack({
        open: true,
        message: "Failed to delete salesperson!",
        type: "error",
      });
    }
  };
  return (
    <div className=" bg-gray-50 min-h-screen">
      <div className="flex justify-between items-center gap-6">
        <h2 className="text-xl text-gray-800 mb-4">Salesperson View</h2>
        <div className="flex justify-between items-center gap-2 mb-4">
          <div className="relative ">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Search by Code..."
              value={searchTerm}
              //   onChange={handleSearch}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
            />
            {searchTerm && (
              <button
                onClick={() => {
                  setSearchTerm("")
                  fetchSalespersons()
                }}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 text-sm"
              >
                ✖
              </button>
            )}
          </div>
          <button
            onClick={handleSearch}
            disabled={!searchTerm.trim()}
            className={`px-2 py-1 rounded ${
              !searchTerm.trim()
                ? "bg-gray-400 cursor-not-allowed text-white"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          >
            <span className="">Search</span>
          </button>
        </div>

        {/* <button
          onClick={onBack}
          className="mb-3 relative bg-gray-600 text-white font-medium text-[17px] px-2 py-[0.25em] pl-3 h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer group"
        >
          <span className="mr-10">Back</span>
          <div className="absolute right-[0.3em] bg-white h-[1.4em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)]">
            <FaArrowLeft className="text-gray-600" />
          </div>
        </button> */}
      </div>

      {error && (
        <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg">
          {error}
        </div>
      )}

      {/* LOADING */}
      {isLoading ? (
        <div className="flex items-center justify-center py-8 my-8">
          <div className="w-10 h-10 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
        </div>
      ) : (
        <>
          {/* TABLE */}
          <div className="overflow-x-auto bg-white rounded-lg shadow max-h-[70vh] overflow-y-auto">
            <table className="min-w-full table-auto border-collapse">
              <thead className="bg-gray-100 sticky top-0">
                <tr>
                  <th className="px-4 py-3 text-sm text-left font-medium text-gray-700 border-b">
                    Code
                  </th>
                  <th className="px-4 py-3 text-sm text-left font-medium text-gray-700 border-b">
                    Name
                  </th>
                  <th className="px-4 py-3 text-sm text-left font-medium text-gray-700 border-b">
                    Department
                  </th>
                  <th className="px-4 py-3 text-sm text-left font-medium text-gray-700 border-b">
                    Account
                  </th>
                  <th className="px-4 py-3 text-sm text-left font-medium text-gray-700 border-b">
                    Target
                  </th>
                  <th className="px-4 py-3 text-sm text-left font-medium text-gray-700 border-b">
                    Email
                  </th>
                  <th className="px-4 py-3 text-sm text-left font-medium text-gray-700 border-b">
                    Mobile No
                  </th>
                  <th className="px-4 py-3 text-sm text-left font-medium text-gray-700 border-b">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {filteredSalespersons.length > 0 ? (
                  filteredSalespersons.map((sp, index) => (
                    <tr key={index} className="hover:bg-blue-50">
                      <td className="px-4 py-2 border-b text-sm">{sp.code}</td>
                      <td className="px-4 py-2 border-b text-sm">
                        {sp.Salesperson_Name}
                      </td>
                      <td className="px-4 py-2 border-b text-sm">
                        {sp.deptno}
                      </td>
                      <td className="px-4 py-2 border-b text-sm">
                        {sp.Account || "-"}
                      </td>
                      <td className="px-4 py-2 border-b text-sm">
                        {sp.Target}
                      </td>
                      <td className="px-4 py-2 border-b text-sm">
                        {sp.Email || sp.email }
                      </td>
                      <td className="px-4 py-2 border-b text-sm">
                        {sp.MobileNo || "-"}
                      </td>

                      <td className="px-4 py-2 border-b text-sm flex gap-2">
                        <button
                          onClick={() => onEdit(sp)}
                          className="px-3 py-1 bg-blue-600 text-white rounded flex items-center gap-1 text-sm"
                        >
                          <FaEdit size={12} /> Edit
                        </button>
                        <button
                          onClick={() => onDeleteSp(sp)}
                          className="px-3 py-1 bg-red-600 text-white rounded flex items-center gap-1 text-sm"
                        >
                          <FaTrash size={12} /> Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-4 text-gray-500">
                      No Salesperson Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.type}
          variant="filled"
          elevation={6}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default SalespersonView;
